import { render, staticRenderFns } from "./SurveyQuestionEditorPulldown.vue?vue&type=template&id=5b63c613&"
import script from "./SurveyQuestionEditorPulldown.vue?vue&type=script&lang=js&"
export * from "./SurveyQuestionEditorPulldown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports